
import React, { useEffect, useState } from 'react'
// import { Bar } from 'react-chartjs-2'
import { Bar } from 'react-chartjs-2'
import Questionnaire from '../../../../../../libs/api/services/Questionnaire'

export default function StatsLabelsGraph({ QuestionnaireId, QuestionnaireAssignmentId, activeLabels, weighting, labels, onItemSeletected }) {
    const [options, setOptions] = useState([])
    const [stats, setStats] = useState({
        labels: [],
        values: [] // {label,weight}
    })


    useEffect(() => {
        const load = async () => setStats(await Questionnaire.GetLabelStats(QuestionnaireId, QuestionnaireAssignmentId))
        load()
    }, [])

    const _toggleOption = (o) => {
        if (options.includes(o))
            setOptions(options.filter(x => x !== o))
        else
            setOptions([...options, o])
    }

    return (
        <>
            <div>
                {stats && <StatsGraph stats={stats} onItemSeletected={onItemSeletected} options={options} activeLabels={activeLabels} />}
                <div>
                    <button
                        onClick={() => _toggleOption('historic')}
                        className={'btn '.concat(options && options.includes('historic') ? '' : 'opacity-75')}>Include Historic Data</button>
                </div>
            </div>
        </>
    )
}

const StatsGraph = ({ stats, onItemSeletected, options, activeLabels }) => {
    const [labels, setLabels] = useState([])
    const [data, setData] = useState()

    useEffect(() => {

        const BuildDataSet = () => {
            if (!stats || !stats.entries) return
            var res = []
            var i = 0
            var _entries = [...stats.entries]
            if (!options.includes('historic') && _entries)
                _entries = stats.entries.filter(a => a.isActive === true)
            console.log(_entries)
            for (const s of _entries) {
                const weights = []
                for (const l of activeLabels) {
                    var lv = s.values.find(x => x.label === l)
                    weights.push(lv ? lv.weight : 0)
                }
                res.push({
                    label: s.caption,
                    type: 'bar',
                    backgroundColor: i++ % 2 === 0 ? '#22aa99' : '#99D1CB',
                    data: [...weights],
                })
            }
            setData({
                type: 'bar',
                labels: activeLabels,
                datasets: res
            })
        }

        BuildDataSet()

    }, [stats, activeLabels, options])

    const _handleItemSelectected = (datasetIdx, itemIdx) => {
        // onItemSeletected([{ source: 'labels-graph', key: data.datasets[datasetIdx].label }])
        // alert(JSON.stringify(data.datasets[datasetIdx]))
        // alert(data.datasets[datasetIdx][itemIdx][0].label)
        // if (weighting.multi)
        //     onItemSeletected([{ source: 'labels-graph', key: dataSetsRefs[datasetIdx][itemIdx][0].label }])
        // else
        //     onItemSeletected([{ source: 'labels-graph', key: dataSetsRefs[itemIdx][0].label }])
    }
    return (<div className='d-flex flex-column align-items-center'>
        {data && <Bar className='align-items-center' options={{
            onClick: function (event, elements) { if (elements && elements.length > 0) _handleItemSelectected(elements[0].datasetIndex, elements[0].index) },
            responsive: false,
            plugins: {
                legend: {
                    display: false
                }
            },
        }}
            data={data} />}
    </div>)

}